import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { getCategoryTree } from '../../../utils/api/course';
import './CoursePackages.scss';

function AuthCell({ status }) {
  const [visible, setVisible] = useState(false);
  if (status === 'granted') return <span className="status-check">✔</span>;
  if (status === 'apply') {
    return (
      <span
        className="auth-apply"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        申请授权
        {visible && (
          <div className="auth-apply__tooltip">
            <div className="auth-apply__tooltip-text">
              请联系集团总部教研负责人，并说明你的申请理由
            </div>
            <div className="auth-apply__tooltip-qr">
              <img src="/image/wuhao.jpg" alt="" />
            </div>
          </div>
        )}
      </span>
    );
  }
  return <span>-</span>;
}

export default function CoursePackages({ onSelectCourseBag }) {
  const [tree, setTree] = useState([]);
  const [selected, setSelected] = useState(null);
  const [btnWidth, setBtnWidth] = useState(null);
  const measureRef = useRef(null);

  const fetchTree = useCallback(() => {
    getCategoryTree().then(res => {
      const data = res?.data || res;
      if (!Array.isArray(data)) return;
      setTree(data);
      for (const sup of data) {
        for (const cat of sup.children || []) {
          setSelected({ superKey: sup.key, catKey: cat.key });
          return;
        }
      }
    });
  }, []);

  useEffect(() => { fetchTree(); }, [fetchTree]);

  // 数据加载后，用隐藏容器量出所有按钮文字中最宽的，加上 padding 得到统一按钮宽度
  useEffect(() => {
    if (!tree.length || !measureRef.current) return;
    const spans = measureRef.current.querySelectorAll('span');
    let max = 0;
    spans.forEach(s => {
      const w = s.getBoundingClientRect().width;
      if (w > max) max = w;
    });
    setBtnWidth(Math.ceil(max) + 16); // padding 12px * 2
  }, [tree]);

  // 收集所有 category 标题，用于隐藏测量容器
  const allCatTitles = useMemo(() => {
    const titles = [];
    tree.forEach(sup => (sup.children || []).forEach(cat => titles.push(cat.title)));
    return titles;
  }, [tree]);

  const courses = useMemo(() => {
    if (!selected) return [];
    for (const sup of tree) {
      if (sup.key !== selected.superKey) continue;
      for (const cat of sup.children || []) {
        if (cat.key === selected.catKey) return cat.children || [];
      }
    }
    return [];
  }, [tree, selected]);

  if (!tree.length) return null;

  return (
    <div className="course-packages">
      {/* 隐藏的测量容器，用于计算最宽按钮文字 */}
      <div ref={measureRef} className="course-packages__measure">
        {allCatTitles.map((t, i) => <span key={i}>{t}</span>)}
      </div>

      <h1 className="course-packages__title">英荔 AI 创造乐园 - 门店课程体系</h1>

      {tree.map(sup => (
        sup.children?.length > 0 && (
          <div key={sup.key} className="macro-section">
            <div className="macro-section__title">{sup.title}</div>
            <div className="macro-section__btn-group"
              style={btnWidth ? { maxWidth: btnWidth * 6 + 10 * 5 } : undefined}
            >
              {sup.children.map(cat => (
                <button
                  key={cat.key}
                  className={`category-btn${selected?.catKey === cat.key ? ' category-btn--active' : ''}`}
                  style={btnWidth ? { width: btnWidth } : undefined}
                  onClick={() => setSelected({ superKey: sup.key, catKey: cat.key })}
                >
                  {cat.title}
                </button>
              ))}
            </div>
          </div>
        )
      ))}

      <hr className="course-packages__divider" />

      <table className="course-table">
        <thead>
          <tr>
            <th className="col-name">课程包名称</th>
            <th className="col-status">课程状态</th>
            <th className="col-auth">授权状态</th>
          </tr>
        </thead>
        <tbody>
          {courses.length === 0 ? (
            <tr>
              <td colSpan={3} className="col-empty">暂无课程包</td>
            </tr>
          ) : courses.map(course => (
            <tr key={course.key}>
              <td className="col-name">
                {(course.is_completed && course.authorization_status === 'granted')
                  ? <span className="col-name__link" onClick={() => onSelectCourseBag?.(course.id)}>{course.title}</span>
                  : course.title
                }
              </td>
              <td className="col-status">
                {course.is_completed
                  ? <span className="status-check">✔</span>
                  : <span className="status-unpublished">暂未发布</span>
                }
              </td>
              <td className="col-auth">
                <AuthCell status={course.authorization_status === 'granted' ? 'granted' : course.is_completed ? 'apply' : '-'} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
